// src/components/KPIBox.js
import React from 'react';
import './KPIBox.css';
import { formatCurrencyShort } from '../utils/format';

function fmtPctSafe(p) {
  const num = Number(p);
  if (!isFinite(num)) return null;
  const sign = num > 0 ? '+' : '';
  return `${sign}${Math.abs(num).toFixed(1)}%`;
}

/**
 * Props:
 * - label, value, isExpense (boolean)
 * - deltaYoY: number (percent; NaN/undefined hides the line)
 */
export default function KPIBox({ label, value, isExpense = false, deltaYoY }) {
  const upIsGood = !isExpense;   // Revenue/Profit: up=good; Expenses: down=good
  const pctText = fmtPctSafe(deltaYoY);
  const hasDelta = pctText !== null;

  let arrow = null, good = false;
  if (hasDelta) {
    const delta = Number(deltaYoY);
    arrow = delta > 0 ? '▲' : (delta < 0 ? '▼' : '•');
    good = upIsGood ? delta > 0 : delta < 0;
  }

  return (
    <div className="kpi-card">
      <div className="kpi-label">{label}</div>

      <div className="kpi-value" style={{ fontVariantNumeric: 'tabular-nums' }}>
        {typeof value === 'number' ? formatCurrencyShort(value) : String(value)}
      </div>

      {hasDelta && (
        <div className="kpi-delta" aria-label="Year over year">
          <span className={`kpi-arrow ${good ? 'good' : 'bad'}`} aria-hidden="true">{arrow}</span>
          <span className={`kpi-pct ${good ? 'good' : 'bad'}`}>{pctText}</span>
          <span className="kpi-sub">vs last year</span>
        </div>
      )}
    </div>
  );
}
